import { toast } from 'react-toastify';
import Toast from '../components/Toast';
import { NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY, NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS, NOTIFICATIONS_DISMISS_POPUP, NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS, NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE, NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS, NOTIFICATIONS_SHOW_ERROR_POPUP, NOTIFICATIONS_SHOW_ERROR_TOAST, NOTIFICATIONS_SHOW_INFO_POPUP, NOTIFICATIONS_SHOW_INFO_TOAST, NOTIFICATIONS_SHOW_SUCCESS_POPUP, NOTIFICATIONS_SHOW_SUCCESS_TOAST } from '../actions/actionTypes/notification-action-types';
import { PopupTypes } from '../components/Popup/PopupV3';

export const initialState = {
    alerts: [],
    popUp: null,
    popupV3: null,
    preRegInviteStatus: {
        canDisplayIfDataExists: true,
        hasCheckedAtLeastOnce: false,
        loading: false,
        error: null,
        data: null,
    },
};

function notificationsReducer(state = initialState, action) {
    switch (action.type) {
        case NOTIFICATIONS_SHOW_ERROR_TOAST: {
            toast.error(Toast, {
                data: {
                    title: action.title || 'Error!',
                    message: action.message,
                    type: 'error',
                },
                icon: false,
            });
            return state;
        }
        case NOTIFICATIONS_SHOW_INFO_TOAST: {
            toast.info(Toast, {
                data: {
                    title: action.title || 'Info!',
                    message: action.message,
                    type: 'info',
                },
                icon: false,
            });
            return state;
        }
        case NOTIFICATIONS_SHOW_SUCCESS_TOAST: {
            toast.success(Toast, {
                data: {
                    title: action.title || 'Success!',
                    message: action.message,
                    type: 'success',
                    actionLabel: action.actionLabel,
                    onAction: action.onAction,
                },
                icon: false,
            });
            return state;
        }
        case NOTIFICATIONS_SHOW_ERROR_POPUP: {
            const {
                title,
                message,
                error,
                confirmButtonLabel,
                onConfirmClick,
                showCancelButton,
                cancelButtonLabel,
                onCancelClick,
                showSupportLink,
            } = action;
            let popupTitle = title;
            let popupMessage = message;
            if (!title) {
                popupTitle = message || 'Error';
                popupMessage = error || '';
            }
            return {
                ...state,
                popupV3: {
                    title: popupTitle,
                    message: popupMessage,
                    type: PopupTypes.ERROR,
                    confirmButtonLabel: confirmButtonLabel || 'OK',
                    onConfirmClick,
                    showCancelButton,
                    cancelButtonLabel: cancelButtonLabel || 'Cancel',
                    onCancelClick,
                    showSupportLink,
                },
            };
        }
        case NOTIFICATIONS_SHOW_INFO_POPUP: {
            const {
                title,
                message,
                confirmButtonLabel,
                onConfirmClick,
                showCancelButton,
                showConfirmButton,
                showCloseButton,
                noIcon,
                cancelButtonLabel,
                onCancelClick,
                onCloseButtonClick,
                enableDoNotShowAgain,
                reverseButtonOrder,
            } = action;
            return {
                ...state,
                popupV3: {
                    title: title !== undefined ? title : 'Info',
                    message,
                    type: PopupTypes.INFO,
                    confirmButtonLabel: confirmButtonLabel || 'OK',
                    onConfirmClick,
                    showCancelButton,
                    showConfirmButton,
                    showCloseButton,
                    noIcon,
                    cancelButtonLabel: cancelButtonLabel || 'Cancel',
                    onCancelClick,
                    onCloseButtonClick,
                    enableDoNotShowAgain,
                    reverseButtonOrder,
                },
            };
        }
        case NOTIFICATIONS_SHOW_SUCCESS_POPUP: {
            const {
                title,
                message,
                confirmButtonLabel,
                onConfirmClick,
                showCancelButton,
                cancelButtonLabel,
                onCancelClick,
            } = action;
            return {
                ...state,
                popupV3: {
                    title: title || 'Success',
                    message,
                    type: PopupTypes.SUCCESS,
                    confirmButtonLabel: confirmButtonLabel || 'OK',
                    onConfirmClick,
                    showCancelButton,
                    cancelButtonLabel: cancelButtonLabel || 'Cancel',
                    onCancelClick,
                },
            };
        }
        case NOTIFICATIONS_DISMISS_POPUP: {
            return {
                ...state,
                popupV3: null,
            };
        }
        case NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS: {
            return {
                ...state,
                preRegInviteStatus: {
                    ...state.preRegInviteStatus,
                    loading: true,
                    error: null,
                    data: null,
                },
            };
        }
        case NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_SUCCESS: {
            return {
                ...state,
                preRegInviteStatus: {
                    ...state.preRegInviteStatus,
                    hasCheckedAtLeastOnce: true,
                    loading: false,
                    error: null,
                    data: action.data,
                },
            };
        }
        case NOTIFICATIONS_FETCH_PRE_REG_INVITE_STATUS_FAILURE: {
            return {
                ...state,
                preRegInviteStatus: {
                    ...state.preRegInviteStatus,
                    loading: false,
                    error: action.error,
                    data: null,
                },
            };
        }
        case NOTIFICATIONS_CLEAR_PRE_REG_INVITE_STATUS: {
            return {
                ...state,
                preRegInviteStatus: {
                    ...state.preRegInviteStatus,
                    loading: false,
                    error: null,
                    data: null,
                },
            };
        }
        case NOTIFICATIONS_CLEAR_PRE_REG_INVITE_CAN_DISPLAY: {
            return {
                ...state,
                preRegInviteStatus: {
                    ...state.preRegInviteStatus,
                    canDisplayIfDataExists: action.canDisplayIfDataExists,
                },
            };
        }
        default:
            return state;
    }
}

export default notificationsReducer;
